<template>
  <v-btn-toggle
    v-model="toggle"
    mandatory
    @change="change"
  >
    <v-btn
      color="#EEEEEE"
    >
      <v-icon
        :color="color1"
      >mdi-circle</v-icon>
    </v-btn>
    <v-btn
      color="#EEEEEE"
    >
      <v-icon
        :color="color2"
      >mdi-circle</v-icon>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  props: {
    color1: {
      type: String,
      default: 'black',
    },
    color2: {
      type: String,
      default: 'white',
    },
  },
  name: 'TwoColorsPicker',
  data: () => ({
    toggle: NaN,
  }),
  methods: {
    change() {
      this.$emit('change', this.currentColor);
    },
  },

  computed: {
    currentColor() {
      return this.toggle === 1 ? this.color2 : this.color1;
    },
  },
};
</script>
